<table *ngIf="isLoaded" mat-table [dataSource]="buildHealthRecords">
    <ng-container matColumnDef="definitionName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Definition</th>
        <td mat-cell *matCellDef="let element">
            <mat-icon class="clickable-icon" 
                (click)="openLinkInNewTab(element.vstsBuildDefinition.editorLink)" 
                matTooltip="OPEN:  Build definition editor"
                matTooltipShowDelay="500">edit</mat-icon>
                <a href="{{element.vstsBuildDefinition.webLink}}" target="_blank" 
                    matTooltip="OPEN: Build definition history" 
                    matTooltipShowDelay="500">{{element.vstsBuildDefinition.displayName}}</a>
        </td>
    </ng-container>
    <ng-container matColumnDef="history">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>History</th>
        <td mat-cell *matCellDef="let element">
            <app-build-history [buildHistory]="element.buildHistory"></app-build-history>
        </td>
    </ng-container>
    <ng-container matColumnDef="lastBuild">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Last Build</th>
        <td mat-cell *matCellDef="let element">
            <a href="{{element.latestBuild.webLink}}" target="_blank" 
                matTooltip="OPEN: Build results" 
                matTooltipShowDelay="500">{{element.latestBuild.buildNumber}}</a></td>
    </ng-container>
    <ng-container matColumnDef="requestedFor">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>User</th>
        <td mat-cell *matCellDef="let element">
            <img class="user-avatar" 
                src="https://vs-pioneer.visualstudio.com/_apis/GraphProfile/MemberAvatars/{{element.latestBuild.requestedFor.descriptor}}">{{element.latestBuild.requestedFor.displayName}}
        </td>
    </ng-container>
    <ng-container matColumnDef="startDate">
        <th class="two-line-date" mat-header-cell *matHeaderCellDef mat-sort-header>Start</th>
        <td mat-cell *matCellDef="let element">
            <div class="two-line-date">
                <span>{{element.latestBuild.startTime | date:'M/d/yy'}}</span>
                <br/>
                <span>{{element.latestBuild.startTime | date:'h:mm a'}}</span>
            </div>
        </td>
    </ng-container>
    <ng-container matColumnDef="finishDate">
        <th class="two-line-date" mat-header-cell *matHeaderCellDef mat-sort-header>Finish</th>
        <td mat-cell *matCellDef="let element">
            <div class="two-line-date" *ngIf="element.latestBuild.status !== 'inProgress'">
                <span>{{element.latestBuild.finishTime | date:'M/d/yy'}}</span>
                <br/>
                <span>{{element.latestBuild.finishTime | date:'h:mm a'}}</span>
            </div>
        </td>
    </ng-container>
    <ng-container matColumnDef="duration">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Duration</th>
        <td mat-cell *matCellDef="let element">{{element.latestBuild.duration}}</td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row;let element; columns: displayedColumns;" 
        [class.has-errors]="element.latestBuild.result === 'failed'" ></tr>
</table>
